<!--登录界面-->
<template>
  <div class="cont_principal">

    <h1 class="title" style="color: #fff">养殖日志管理后台系统</h1>
    <!--<img src="./../assets/spictures/logo.jpg" alt="" style="width: 200px;position: absolute;right: 40px;bottom: 40px;">-->
    <div class="cont_centrar">
      <div class="cont_login">
        <form action="" class="submit_form">
          <div class="cont_tabs_login">
            <ul class='ul_tabs'>
              <li class="active"><a href="#" @click="sign_in()">登录</a>
                <span class="linea_bajo_nom"></span>
              </li>
              <li><a href="#" @click="sign_up()">注册</a><span class="linea_bajo_nom"></span>
              </li>
            </ul>
          </div>
          <div class="cont_text_inputs">
            <input type="text" class="input_form_sign d_block active_inp" placeholder="请输入用户名"  v-model="username"/>
            <input type="password" class="input_form_sign d_block  active_inp" placeholder="请输入密码"  v-model="password"/>
            <input type="password" class="input_form_sign" placeholder="确认密码" v-model="confWord" />
          </div>
          <div class="role_style">
            <el-radio v-model="role" label="ROLE_USER">普通用户</el-radio>
            <!--<el-radio v-model="role" label="ROLE_EXPERT">专家</el-radio>-->
          </div>
          <div class="cont_btn">
            <button class="btn_sign" @click="submit">登录</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
 import request from '../http/auth'
export default {
  name: 'Login',
  data () {
    return {
      /*用户角色,普通用户还是专家*/
      role: 'ROLE_USER',
      /*表单数据*/
      username: '',
      password: '',
      confWord: ''
    }
  },
  methods: {
    /*阻止表单的默认行为--->提交表单后刷新网页
    * 解决问题:登录注册提交表单后会自动刷新,无法触发submit(),取消表单默认行为,并在submit函数最开始调用次函数,即可解决问题
    * */
    preventFormAction(){
      let form = document.querySelector('.submit_form')
      form.onsubmit = () =>{
        return false
      }
    },
    /*注册函数*/
    sign_up() {
      let inputs = document.querySelectorAll('.input_form_sign');
      //显示单选框
      document.querySelector('.role_style').style.display = "block"
      document.querySelectorAll('.ul_tabs > li')[0].className = "";
      document.querySelectorAll('.ul_tabs > li')[1].className = "active";
      for (let i = 0; i < inputs.length; i++) {
        // eslint-disable-next-line no-empty
        if (i == 2) {

        } else {
          document.querySelectorAll('.input_form_sign')[i].className = "input_form_sign d_block";
        }
      }
      setTimeout(function () {
        for (let d = 0; d < inputs.length; d++) {
          document.querySelectorAll('.input_form_sign')[d].className = "input_form_sign d_block active_inp";
        }
      }, 10);
      document.querySelector('.btn_sign').innerHTML = "注册";
    },
    /*登录函数*/
    sign_in() {
      let inputs = document.querySelectorAll('.input_form_sign');
      document.querySelector('.role_style').style.display = "none";
      document.querySelectorAll('.ul_tabs > li')[0].className = "active";
      document.querySelectorAll('.ul_tabs > li')[1].className = "";
      for (let i = 0; i < inputs.length; i++) {
        switch (i) {
          case 1:
            console.log(inputs[i].name);
            break;
          case 2:
            console.log(inputs[i].name);
            break;
          default:
            document.querySelectorAll('.input_form_sign')[i].className = "input_form_sign d_block";
        }
      }
      setTimeout(function () {
        for (let d = 0; d < inputs.length; d++) {
          switch (d) {
            case 1:
              console.log(inputs[d].name);
              break;
            case 2:
              console.log(inputs[d].name);
              break;
            default:
              document.querySelectorAll('.input_form_sign')[0].className = "input_form_sign d_block active_inp";
              document.querySelectorAll('.input_form_sign')[1].className = "input_form_sign d_block active_inp";
          }
        }
      }, 10);

      setTimeout(function () {
        for (let d = 0; d < inputs.length; d++) {

          switch (d) {
            case 1:
              console.log(inputs[d].name);
              break;
            case 2:
              console.log(inputs[d].name);

              break;
            default:
              document.querySelectorAll('.input_form_sign')[2].className = "input_form_sign";
          }
        }
      }, 150);
      document.querySelector('.btn_sign').innerHTML = "登录";
    },
    /*按钮请求*/
    async submit(){
      this.preventFormAction()
     let value = document.querySelector('.btn_sign').innerHTML
     // console.log("xixi"+value)
      let loginData = { //登录使用数据
        username : this.username, //用户名
        password: this.password // 密码
      }
      let signInData = {  //注册使用数据
        password: this.password, //密码
        role: this.role, //用户角色
        username: this.username //用户名
      }

      /*登录请求*/
      if (value === '登录'){
        if (!this.password || !this.username)
        {
          this.$message({
            message: '用户名或密码不能为空',
            type: 'warning'
          });
          return ;
        }
        /*登录请求*/
        // console.log("登录");
        let res = await  request.login(loginData);
        // console.log("登录",res);
        if(res.data){
          this.$message({
            message: '登录成功',
            type: 'success'
          });
          window.sessionStorage.setItem("token", res.data.token)
          window.sessionStorage.setItem("name",res.data.username)
          this.$router.push('/userHome')
          //window.sessionStorage.setItem("role", res.data.role)
          //console.log(window.sessionStorage.getItem("role"));
          //实现按照不同角色跳转
          //if (window.sessionStorage.getItem("role") === "ROLE_USER"){
          //  this.$router.push('/userHome')
          //}else if (window.sessionStorage.getItem("role") === "ROLE_EXPERT"){
            //this.$router.push('/expertHome')
          //}
          //this.$router.push('/Home')
        }else {
          this.$message({
            message: '账号或密码错误',
            type: 'error'
          });
        }
      }
      /*注册请求*/
      if (value === '注册'){
        if (!this.password || !this.username || !this.confWord)
        {
          this.$message({
            message: '用户名或密码不能为空',
            type: 'warning'
          });
          return ;
        }
        /*注册请求*/
       let ret =await request.register(signInData)
      // console.log(ret);
        if(ret.msg === "SUCCESS"){
          this.$message({
            message: '注册成功',
            type: 'success'
          });
         // this.$router.push('/Login')
          // 刷新当前页面,回到登录状态
          location.reload()
        }else {
          this.$message({
            message: '注册失败,该用户已存在',
            type: 'error'
          });
      }
      }
    }
  },
  mounted() {
      document.querySelector('.cont_centrar').className = "cont_centrar cent_active";
  }
}

</script>

<style scoped>
  * {
    margin: 0px auto;
    padding: 0px;
    font-family: 'Open Sans', sans-serif;
  }
  .cont_principal {
    position: absolute;
    width: 100%;
    height: 100%;
    background: url("../assets/background.jpg") no-repeat;
    background-size: cover;
  }

  .cont_centrar {
    position: absolute;
    width: 320px;
    left:50%;
    top:50%;
    margin-left: -160px;
    margin-top: -160px;
  }

  .cont_centrar {
    position: relative;
    width: 320px;
    float: left;
    background-image: linear-gradient(-226deg, #FFFFFF 8%, #EEF3F5 100%);

    border-radius: 8px;
    transition: all 0.5s;
  }

  .cent_active {
    box-shadow: 5px 5px 10px 0px rgba(0,0,0,0.21);
  }


  .cont_tabs_login {
    position: relative;
    float: left;
    width: 100%;
  }

  .ul_tabs > li {
    position: relative;
    float: left;
    width: 50%;
    list-style: none;
    text-align: center;

  }

  .ul_tabs > li > a  {
    text-decoration: none;
    font-family: Helvetica;
    font-size: 16px;
    color: #999;
    line-height: 14px;
    padding: 20px ;
    display: block;
    transition: all 0.5s;
  }

  .ul_tabs > .active > a  {
    color: #409EFF;

  }

  .linea_bajo_nom {
    position: relative;
    width: 100%;
    float: left;
    background-color: #999;
    height: 2px;
  }

  .active .linea_bajo_nom {
    position: relative;
    width: 100%;
    float: left;
    background-color: #409EFF;
    height: 2px;
  }

  .cont_text_inputs {
    position: relative;
    float: left;
    width: 100%;
    margin-top: 20px;
  }

  .input_form_sign {
    position: relative;
    float: left;
    width: 90%;
    border: none;
    border-bottom: 1px solid #B0BEC5 ;
    background-color: transparent;
    font-size: 14px;
    outline: none;
    transition: all 0.5s;
    height: 0px;
    margin: 0px;
    padding: 0px;
    opacity: 0;
    display: none;
  }

  .active_inp {
    margin: 5% 5% ;
    padding: 10px 0px;
    opacity: 1;
    height: 5px;
  }



  .input_form_sign:focus {
    border-bottom: 1px solid #409EFF ;}

  .link_forgot_pass {
    position: relative;
    margin-top: 0px;
    margin-left: 30%;
    text-decoration: none;
    color: #999;
    font-size: 13px;
    display: none;
    float: left;
    transition: all 0.5s;
  }
  .cont_btn {
    position: relative;
    float: left;
  }

  .btn_sign {
    background: #409EFF;
    border-radius: 8px;
    padding: 15px 30px;
    border: none;
    color: #fff;
    font-size: 14px;
    position: relative;
    float: left;
    margin-left: 100px;
    margin-top: 20px;
    margin-bottom: 20px;
    cursor: pointer;
  }
  .d_none {
    display: none;
  }

  .d_block {
    display: block;
  }

  .cont_text_inputs > input:nth-child(1){
    transition-delay: 0.2s;
  }

  .cont_text_inputs > input:nth-child(2){
    transition-delay: 0.4s;
  }
  .cont_text_inputs > input:nth-child(3){
    transition-delay: 0.6s;
  }
  .cont_text_inputs > input:nth-child(4){
    transition-delay: 0.8s;
  }
  .title{
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 14%;
    color: rgba(0,0,0,0.7);
  }
  .role_style{
    display: none;
   text-align: center;
  }
</style>
